import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const CheckMark = ({
  color = '#38AF88',
}: IconProps): React.ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6087 6.20666C19.0469 6.54285 19.1296 7.1706 18.7934 7.60877L11.121 17.6088C10.9442 17.8391 10.6762 17.9813 10.3864 17.9983C10.0965 18.0154 9.81363 17.9057 9.6111 17.6977L5.28353 13.2531C4.89825 12.8574 4.90669 12.2243 5.30238 11.839C5.69808 11.4538 6.33119 11.4622 6.71647 11.8579L10.2377 15.4743L17.2066 6.39133C17.5428 5.95316 18.1705 5.87048 18.6087 6.20666Z"
      fill={color}
    />
  </svg>
);
export default CheckMark;
